module.exports = __webpack_public_path__ + "static/img/2.1038659.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/sample/2.png
// module id = 3NI8
// module chunks = 0